var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { Flex, Text } from 'pcln-design-system';
import { ArrowUp, DollarCircle, Dot, Luggage, Pin, Seat, Smartphone, Success } from 'pcln-icons';
import ContentfulRichText from '../ContentfulRichText';
var icons = {
    ArrowUp: ArrowUp,
    DollarCircle: DollarCircle,
    Luggage: Luggage,
    Pin: Pin,
    Seat: Seat,
    Smartphone: Smartphone,
    Success: Success,
};
/** @public */
function ContentfulListItem(_a) {
    var iconName = _a.iconName, label = _a.label, props = __rest(_a, ["iconName", "label"]);
    var Icon = icons[iconName] || Dot;
    return (React.createElement(Flex, __assign({}, props),
        React.createElement(Icon, { size: 14, title: iconName || 'Dot', mr: 2 }),
        label.data ? (React.createElement(ContentfulRichText, { body: label, fontSize: 0, m: 0 })) : (React.createElement(Text, { fontSize: 0 }, label))));
}
export default memo(ContentfulListItem);
//# sourceMappingURL=ContentfulListItem.js.map